import { useMemo } from "react";
import { UNASSIGNED_TAG } from "@lifeat/shared/task-management/TaskTagConstants";
import { Tag } from "@lifeat/shared/task-management/TaskTagTypes";
import { useDebouncedInput } from "@common/LifeAtTextInput/useDebouncedInput";
import { useTaskListContext } from "../TaskListContext";
import { getTaskTagFromTagArray } from "../TaskManagementUtil";
import { DEFAULT_TAG_ID } from "../components/TaskItemConstants";

const DEBOUNCE_DELAY_MS = 1000;

export function useTagAssignmentInput(props: {
    taskTagId: string | null | undefined;
    updateTaskTag: (tagId: string | null) => Promise<void>;
    onAssign: (tagId: string) => void;
    onRemove: () => void;
}): [selectedTagId: string, setSelectedTagId: (tagId: string) => void, selectedTag: Tag] {
    const { tags } = useTaskListContext();

    const [selectedTagId, setSelectedTagId] = useDebouncedInput(
        props.taskTagId ?? DEFAULT_TAG_ID,
        async (updatedTagId: string) => {
            const newTagId = updatedTagId === DEFAULT_TAG_ID ? null : updatedTagId;
            await props.updateTaskTag(newTagId);
            if (newTagId == null) {
                props.onRemove();
            } else {
                props.onAssign(newTagId);
            }
        },
        DEBOUNCE_DELAY_MS,
    );

    const selectedTag = useMemo(
        () => getTaskTagFromTagArray(selectedTagId, tags) ?? UNASSIGNED_TAG,
        [selectedTagId, tags],
    );

    return [selectedTagId, setSelectedTagId, selectedTag];
}
